<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <!-- Breadcrumb Navigation -->
      <nav
        class="d-flex align-items-center flex-wrap gap-2 mb-2"
        aria-label="breadcrumb"
      >
        <a
          class="back-link d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
          routerLink="/applicationConfiguration"
          [title]="'COMMON.BACK' | translate"
          (click)="goBack()"
        >
          <mat-icon class="text-primary">arrow_back</mat-icon>
        </a>

        <div class="d-flex align-items-center">
          <mat-icon class="me-3" color="primary">email</mat-icon>
          <p class="fw-semibold mb-0" style="font-size: 20px">
            {{
              "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.EMAIL_CON"
                | translate
            }}
          </p>
        </div>

        <span class="text-secondary mx-2">/</span>
        <span class="text-secondary">{{
          "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.EMAIL_CON"
            | translate
        }}</span>
      </nav>
    </div>

    <div class="col-lg-12">
      <div class="card">
        <div class="card-header p-3">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap gap-3"
          >
            <div>
              <h5 class="mb-1 d-flex align-items-center text-muted">
                <mat-icon class="me-3">settings_applications</mat-icon>
                <span>{{
                  "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Email_Server_Configuration"
                    | translate
                }}</span>
              </h5>
              <p class="text-muted small mb-0">
                {{
                  "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Outgoing_Mail"
                    | translate
                }}
              </p>
            </div>

            <!-- Connection Status Badge -->
            <div
              class="d-flex align-items-center bg-light smtp-light px-3 py-2 rounded-3"
            >
              <span
                class="badge bg-success me-2"
                style="
                  width: 10px;
                  height: 10px;
                  padding: 0;
                  border-radius: 50%;
                "
              ></span>
              <span class="small fw-semibold">{{
                "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Ready"
                  | translate
              }}</span>
            </div>
          </div>
        </div>
        <!-- Alerts -->
        <app-ncs-alert
          *ngIf="form['message']"
          [message]="form['message']"
          class="m-3"
          [type]="form['error'] ? 'danger' : 'success'"
        >
        </app-ncs-alert>
        <!-- Form -->
        <div class="card-body email-box">
          <form #smtpForm="ngForm">
            <div class="row g-4">
              <!-- SMTP Host -->
              <div class="col-12">
                <label
                  for="smtpHost"
                  class="form-label fw-semibold text-secondary mb-2"
                >
                  <i class="bx bx-server me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Host"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>

                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="smtpHost"
                    name="smtpHost"
                    type="text"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Host_Place'
                        | translate
                    }}"
                    [(ngModel)]="emailConfigForm.data['smtpHost']"
                    required
                  />
                </mat-form-field>

                <div class="mt-2">
                  <small class="text-muted d-block mb-1">
                    <i class="bx bx-info-circle me-1"></i>
                    <span class="fw-medium">{{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Default"
                        | translate
                    }}</span>
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Empty"
                        | translate
                    }}
                  </small>
                  <small class="text-muted d-block">
                    <i class="bx bx-detail me-1"></i>
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_DETAILS_Part1"
                        | translate
                    }}
                    <span class="text-muted">{{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_DETAILS_Part2"
                        | translate
                    }}</span
                    >.
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_DETAILS_Part3"
                        | translate
                    }}
                  </small>
                </div>
                <small class="text-danger d-block mt-2">{{
                  form.inputerror["smtpHost"]
                }}</small>
              </div>

              <!-- SMTP Security & Auth Type - Two columns for better space utilization -->
              <div class="col-md-6">
                <label
                  for="smtpSecurity"
                  class="form-label fw-semibold text-secondary mb-2"
                >
                  <i class="bx bx-shield-quarter me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Security"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    id="smtpSecurity"
                    name="smtpSecurity"
                    [(ngModel)]="emailConfigForm.data['smtpSecurity']"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Security_Place'
                        | translate
                    }}"
                    required
                  >
                    <mat-option value="SSL">SSL</mat-option>
                    <mat-option value="TLS">TLS</mat-option>
                    <mat-option value="NONE">None</mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="mt-2">
                  <small class="text-muted d-block">
                    <i class="bx bx-info-circle me-1"></i>
                    <span class="fw-medium">{{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Default"
                        | translate
                    }}</span>
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.None"
                        | translate
                    }}
                  </small>
                  <small class="text-muted d-block mt-1">
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Security_Details"
                        | translate
                    }}
                  </small>
                </div>
                <small class="text-danger d-block mt-2">{{
                  form.inputerror["smtpSecurity"]
                }}</small>
              </div>

              <div class="col-md-6">
                <label
                  for="smtpAuthType"
                  class="form-label fw-semibold text-secondary mb-2"
                >
                  <i class="bx bx-key me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Auth_Type"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    id="smtpAuthType"
                    name="smtpAuthType"
                    [(ngModel)]="emailConfigForm.data['smtpAuthType']"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Auth_Type_Place'
                        | translate
                    }}"
                    required
                  >
                    <mat-option value="LOGIN">LOGIN</mat-option>
                    <mat-option value="PLAIN">PLAIN</mat-option>
                    <mat-option value="CRAM-MD5">CRAM-MD5</mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="mt-2">
                  <small class="text-muted d-block">
                    <i class="bx bx-info-circle me-1"></i>
                    <span class="fw-medium">{{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Default"
                        | translate
                    }}</span>
                    LOGIN
                  </small>
                  <small class="text-muted d-block mt-1">
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Auth_Type_Details"
                        | translate
                    }}
                  </small>
                </div>
                <small class="text-danger d-block mt-2">{{
                  form.inputerror["smtpAuthType"]
                }}</small>
              </div>

              <!-- SMTP Username & Password - Two columns -->
              <div class="col-md-6">
                <label
                  for="smtpUser"
                  class="form-label fw-semibold text-secondary mb-2"
                >
                  <i class="bx bx-user me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Username"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>

                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="smtpUser"
                    name="smtpUser"
                    type="email"
                    placeholder="{{
                      'EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Username_Place'
                        | translate
                    }}"
                    [(ngModel)]="emailConfigForm.data['smtpUser']"
                    required
                  />
                </mat-form-field>
                <div class="mt-2">
                  <small class="text-muted d-block">
                    <i class="bx bx-info-circle me-1"></i>
                    <span class="fw-medium">{{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Default"
                        | translate
                    }}</span>
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Empty"
                        | translate
                    }}
                  </small>
                  <small class="text-muted d-block mt-1">
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Username_Details"
                        | translate
                    }}
                  </small>
                </div>
                <small class="text-danger d-block mt-2">{{
                  form.inputerror["smtpUser"]
                }}</small>
              </div>

              <div class="col-md-6">
                <label
                  for="smtpPass"
                  class="form-label fw-semibold text-secondary mb-2"
                >
                  <i class="bx bx-lock-alt me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Password"
                      | translate
                  }}
                  <span class="text-danger">*</span>
                </label>

                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="smtpPass"
                    name="smtpPass"
                    [type]="hidePassword ? 'password' : 'text'"
                    [(ngModel)]="emailConfigForm.data['smtpPass']"
                    required
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    class="icon-pd-none"
                    (click)="hidePassword = !hidePassword"
                  >
                    <mat-icon>{{
                      hidePassword ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </button>
                </mat-form-field>
                <div class="mt-2">
                  <small class="text-muted d-block">
                    <i class="bx bx-info-circle me-1"></i>
                    <span class="fw-medium">{{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Default"
                        | translate
                    }}</span>
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Empty"
                        | translate
                    }}
                  </small>
                  <small class="text-muted d-block mt-1">
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Password_Details"
                        | translate
                    }}
                  </small>
                </div>
                <small class="text-danger d-block mt-2">{{
                  form.inputerror["smtpPass"]
                }}</small>
              </div>

              <!-- SMTP Session Limit -->
              <div class="col-12">
                <label
                  for="smtpSessionLimit"
                  class="form-label fw-semibold text-secondary mb-2"
                >
                  <i class="bx bx-layer me-1 text-primary"></i
                  >{{
                    "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Session_Limit"
                      | translate
                  }}<span class="text-danger">*</span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="smtpSessionLimit"
                    name="smtpSessionLimit"
                    type="number"
                    min="1"
                    [(ngModel)]="emailConfigForm.data['smtpSessionLimit']"
                    required
                  />
                </mat-form-field>
                <div class="mt-2">
                  <small class="text-muted d-block">
                    <i class="bx bx-info-circle me-1"></i>
                    <span class="fw-medium">{{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Default"
                        | translate
                    }}</span>
                    1
                  </small>
                  <small class="text-muted d-block mt-1">
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.SMTP_Session_Limit_Details"
                        | translate
                    }}
                  </small>
                </div>
                <small class="text-danger d-block mt-2">{{
                  form.inputerror["smtpSessionLimit"]
                }}</small>
              </div>
            </div>
          </form>
        </div>

        <!-- Footer -->
        <div class="card-footer bg-transparent">
          <div class="d-flex justify-content-end gap-3 py-3">
            <button
              type="button"
              mat-stroked-button
              color="warn"
              (click)="goBack()"
            >
              <mat-icon>close</mat-icon>
              {{
                "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Cancel"
                  | translate
              }}
            </button>

            <button
              type="button"
              mat-flat-button
              color="primary"
              [disabled]="!smtpForm.valid"
              (click)="saveSMTPConfig()"
            >
              <mat-icon>save</mat-icon>
              {{
                "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Save"
                  | translate
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
